import React from 'react';

export const Footer = (props: any) => {

  return (
    <React.Fragment>
      <footer id="footer">
        <div className="container">
          <div className="footer">
            <div className="left_part">

            </div>
            <div className="right_part">
              <p>© 2022 reserved to Yayasan Multimedia Nusantara</p>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  )


}





